export default function StatsBar() {
  return (
    <section className="bg-foreground-950 py-8 md:py-10">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-0 md:divide-x md:divide-foreground-800">
          <div className="flex flex-col items-center text-center md:px-8">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/10 mb-3">
              <i className="ri-calendar-check-line text-primary-400 text-lg" />
            </div>
            <span className="text-white font-bold text-2xl uppercase leading-none">+10 Anos</span>
            <span className="text-foreground-500 text-xs mt-1 uppercase tracking-wide">de Experiência</span>
          </div>
          <div className="flex flex-col items-center text-center md:px-8">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/10 mb-3">
              <i className="ri-map-pin-2-line text-primary-400 text-lg" />
            </div>
            <span className="text-white font-bold text-2xl uppercase leading-none">Brasil</span>
            <span className="text-foreground-500 text-xs mt-1 uppercase tracking-wide">Atendimento Nacional</span>
          </div>
          <div className="flex flex-col items-center text-center md:px-8">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/10 mb-3">
              <i className="ri-tools-fill text-primary-400 text-lg" />
            </div>
            <span className="text-white font-bold text-2xl uppercase leading-none">12 Modelos</span>
            <span className="text-foreground-500 text-xs mt-1 uppercase tracking-wide">de Máquinas</span>
          </div>
          <div className="flex flex-col items-center text-center md:px-8">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/10 mb-3">
              <i className="ri-customer-service-2-line text-primary-400 text-lg" />
            </div>
            <span className="text-white font-bold text-2xl uppercase leading-none">Suporte</span>
            <span className="text-foreground-500 text-xs mt-1 uppercase tracking-wide">Técnico Especializado</span>
          </div>
        </div>
      </div>
    </section>
  );
}